/**
 * Session storage keys for OAuth flow
 */
export const SESSION_KEYS = {
    PKCE_VERIFIER: 'pkce_verifier',
    PKCE_STATE: 'pkce_state',
    OAUTH_FLOW_STARTED: 'oauth_flow_started',
    PENDING_AUTH_ERROR: 'pending_auth_error',
    USE_LEGACY_LOGIN: 'use_legacy_login',
    AUTH_ERROR: 'AUTH_ERROR'
} as const;

/**
 * Error messages for user-facing errors
 */
export const ERROR_MESSAGES = {
    MISSING_PARAMS: 'Missing authentication parameters',
    STATE_MISMATCH: 'Security validation failed. Please sign in again.',
    SESSION_EXPIRED: 'Authentication session expired. Please sign in again.',
    AUTH_FAILED: 'Authentication failed',
    REQUEST_TIMEOUT: 'Authentication is taking too long. Please try again.'
} as const;

/**
 * Error codes for programmatic error handling
 */
export const ERROR_CODES = {
    MISSING_PARAMS: 'missing_parameters',
    INVALID_STATE: 'invalid_state',
    SESSION_EXPIRED: 'session_expired',
    AUTH_FAILED: 'authentication_failed',
    NETWORK_ERROR: 'network_error',
    INVALID_GRANT: 'invalid_grant',
    INVALID_REQUEST: 'invalid_request',
    SERVER_ERROR: 'server_error',
    TOO_MANY_REQUESTS: 'too_many_requests',
    TOKEN_EXCHANGE_FAILED: 'token_exchange_failed',
    REQUEST_TIMEOUT: 'request_timeout'
} as const;

/**
 * OAuth configuration
 */
export const OAUTH_CONFIG = {
    REQUEST_TIMEOUT_MS: 30000,
    OAUTH_FLOW_MAX_AGE_MS: 600000 // 10 minutes
} as const;

/**
 * Auth routes
 */
export const AUTH_ROUTES = {
    SIGNIN: '/auth/signin',
    AUTH_PREFIX: '/auth/',
    PASSWORD: '/password',
    RESET_PASSWORD: '/auth/reset-password',
    INVITE: '/invite',
    CALLBACK: '/auth/callback'
} as const;